/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconOverhead: {
  name: 'overhead';
  data: string;
} = {
  name: 'overhead',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 612 612"><path d="M83.291 228.523c138.146 0 143.746 1.867 143.746 1.867C405.211-59.18 546.273 334.821 564.559 477.36l-52.193.226 102.106 178.24 98.052-177.693-50.78-2.094C544.607 67.318 230.65 49.311 83.291 228.523z" transform="translate(-53.253 -63.806) scale(.91934)"/></svg>`,
};
